import { Box, ClickAwayListener, Grow, Paper, Popper, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enUS, ja } from 'date-fns/locale';
import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../../constants/language';
import { LANG_DISPLAY_KEY } from '../../../../consts/language';
import { getEndOfDay, getStartOfDay } from '../../../../utils/handleDateTime';

interface DatePickerProps {
  onSelect: (start: Date | null, end: Date | null) => void;
  defaultToday?: boolean;
  minDate?: Date;
}

const DatePickerCustom: React.FC<DatePickerProps> = ({ onSelect, defaultToday = true, minDate }) => {
  const { t } = useTranslation();
  const anchorRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(false);
  const today = new Date();

  const [startDate, setStartDate] = useState<Date | null>(defaultToday ? getStartOfDay(today) : null);
  const [endDate, setEndDate] = useState<Date | null>(defaultToday ? getEndOfDay(today) : null);

  const onChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      setOpen(false);
      onSelect(getStartOfDay(start), getEndOfDay(end));
    }
  };

  return (
    <Box sx={{ zIndex: 9999, padding: '8px' }}>
      <Box>
        <TextField
          id="date"
          label={t(LANG_TEXT.DATE_FILTER)}
          type="text"
          value={startDate && endDate ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}` : t(LANG_TEXT.DATE_FILTER)}
          InputProps={{
            readOnly: true,
            sx: { '& .MuiInputBase-input': { padding: '8px' } },
          }}
          ref={anchorRef}
          onClick={() => setOpen(!open)}
        />
      </Box>
      <Popper id="datepicker-popper" anchorEl={anchorRef.current} open={open} placement="bottom-end" transition disablePortal>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Grow {...TransitionProps}>
              <Paper elevation={0} sx={{ background: 'none' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localStorage.getItem(LANG_DISPLAY_KEY) || 'ja'}>
                  <DatePicker
                    selected={startDate}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    inline
                    minDate={minDate}
                    locale={localStorage.getItem(LANG_DISPLAY_KEY) === 'en' ? enUS : ja}
                  />
                </LocalizationProvider>
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </Box>
  );
};

export default DatePickerCustom;
